import { render, staticRenderFns } from "./TableAttributePicker.vue?vue&type=template&id=361861b4&scoped=true"
import script from "./TableAttributePicker.vue?vue&type=script&lang=js"
export * from "./TableAttributePicker.vue?vue&type=script&lang=js"
import style0 from "./TableAttributePicker.vue?vue&type=style&index=0&id=361861b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361861b4",
  null
  
)

export default component.exports